module.exports = __webpack_public_path__ + "img/electric-sheath.bc4a0f7.svg";